import { render, staticRenderFns } from "./SubscriptionPolicy.vue?vue&type=template&id=c2cb7cc8&scoped=true&"
import script from "./SubscriptionPolicy.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPolicy.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPolicy.vue?vue&type=style&index=0&id=c2cb7cc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cb7cc8",
  null
  
)

export default component.exports